<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtu.be/Bix3vmXZd4o"
    >
        <template v-slot:feature-summary>
            <img class="" :src="buildImgUrl('feature_summary.png')" alt="Bloomitの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('contents01.png')"
                     alt="思わず目を惹くくりっとおめめ パフ仕立てのようなさらっとやわ肌 やりすぎてないけど可愛い盛れ感♥">
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <div class="cont-02-bk">
                    <img class="img-01" :src="buildImgUrl('contents02_01.png')" alt="8人でもこの盛れ感!!">
                    <img class="img-02" :src="buildImgUrl('contents02_02.png')"
                         alt="グループでも盛れるヒミツは・・・みんなに光が当たって盛れる4人まで並べる盛れるライン　前後に並んでも超盛れる盛れるステップ">
                </div>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <div class="cont-03-bk">
                    <img class="cont-03-bk-title" :src="buildImgUrl('contents03_01.png')"
                         alt="撮影中からバランスよく撮れる♥ “バランスジャッジ”">
                    <img class="cont-03-bk-gif" :src="buildImgUrl('contents03.gif')" alt="gif">
                    <img class="img-02" :src="buildImgUrl('contents03_02.png')"
                         alt="中心がズレてしまったプリ画を自動で整える！“バランス補正” 2人でもグループでも仕上がりUP！">
                </div>
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <div class="cont-04-bk">
                    <img class="img-01" :src="buildImgUrl('contents04_01.png')"
                         alt="一度使ったメイクの履歴が他のプリにも使えて超時短！“メイクりれき” ボタンを押すと履歴上のメイクが簡単反映★">
                    <img class="img-02" :src="buildImgUrl('contents04_02.png')"
                         alt="New 左右同時に同じプリのメイクができる！“左右同時プリ画選択” 友達の操作を待たなくて済むから超時短★">
                </div>
            </div>
        </template>
        <template v-slot:content-5>
            <div class="cont-05">
                <div class="cont-05-bk">
                    <img class="img-01" :src="buildImgUrl('contents05_01.png')"
                         alt="シールふちにペンやスタンプで自由に落書きが出来る！作ったシールはみんなオソロイで超可愛い♥ 種類もカラーも豊富で可愛いペン 本物のシールみたいで可愛いスタンプ">
                    <img class="img-02" :src="buildImgUrl('contents05_02.png')"
                         alt="＼超富なレイアウトで8人までみ〜んな貰える★／">
                </div>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineBloomit1",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        machineId() {
            return 161;
        },
        sectionTitleList() {
            return [
                '01 さらっと質感が超可愛い さらパフ盛れ',
                '02 グループでも盛れる衝撃！人数別の盛れ方公開',
                '03 もう失敗しない！？バランスよく撮れる新機能',
                '04 レタッチメイクが超時短に！！NEW落書き機能',
                '05 みんなで作れて楽しいオソロシールカスタム',
            ];
        }
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        }
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(355px, $deviceWidth));
                left: 0;
                width: 100%;

                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }

            .list-anchor-link {
                padding: (variables.$grid-consistent * 2) 0 0;

                .img-link {
                    width: math.percentage(math.div(594px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(594px, $deviceWidth));
                    display: block;
                    margin: auto;
                }

                &-feature-summary {
                    background-image: v-bind("buildStyleImgUrl('link_bk.png')");
                    background-repeat: no-repeat;
                    background-size: 100%;
                }
            }

            .feature-summary {
                width: math.percentage(math.div(594px, $deviceWidth));
                margin: auto;
            }
        }

        &-contents {
            .accordion-inner {
                .img-01, .img-02, .img-03, .img-04, .img-05 {
                    display: block;
                }

                .cont-02 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('contents02_bk.png')");
                        background-size: cover;
                    }
                }

                .cont-03 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('contents03_bk.png')");
                        background-size: cover;

                        &-title {
                            width: math.percentage(math.div(400px, $deviceWidth));
                            margin: 16px auto;
                        }

                        &-gif {
                            width: math.percentage(math.div(640px, $deviceWidth));
                            margin: 0 auto 16px auto;
                        }
                    }
                }

                .cont-04 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('contents04_bk.png')");
                        background-size: cover;
                    }
                }

                .cont-05 {
                    &-bk {
                        background: v-bind("buildStyleImgUrl('contents05_bk.png')");
                        background-size: cover;
                    }
                }
            }
        }

        &-movie {
            padding: variables.$grid-consistent * 18 0 variables.$grid-consistent * 13;
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            &-thumb {
                width: math.percentage(math.div(650px, $deviceWidth));
                margin: auto auto 80px auto;
            }
        }
    }
}

</style>
